import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=27d1483c&scoped=true&"
import script from "./ShopList.vue?vue&type=script&lang=js&"
export * from "./ShopList.vue?vue&type=script&lang=js&"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=27d1483c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d1483c",
  null
  
)

export default component.exports